export default "__VITE_ASSET__89523b33__"